import React from 'react';

import PropTypes from 'prop-types';

import IconSelection from 'components/settings/projectConfiguration/ppeRequirements/IconSelection';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function PpeRequirementsSection({ iconAllocations, icons }) {
  return (
    <div className='tw-grid tw-grid-cols-5 tw-gap-x-2 tw-gap-y-3 min-w-1200:tw-grid-cols-4'>
      {icons.map((icon, index) => {
        const iconAllocation = iconAllocations.find(
          (allocation) => allocation.relationships.icon.data.id === icon.id,
        );

        return (
          <IconSelection
            icon={icon}
            iconAllocation={iconAllocation}
            index={index}
            key={icon.id}
          />
        );
      })}
    </div>
  );
}

PpeRequirementsSection.propTypes = {
  iconAllocations: PropTypes.arrayOf(resourceShape('iconAllocation'))
    .isRequired,
  icons: PropTypes.arrayOf(resourceShape('icon')).isRequired,
};
